var map = {
	"./locale/ar_EG.ts": "./components/locale/ar_EG.ts",
	"./locale/az_AZ.ts": "./components/locale/az_AZ.ts",
	"./locale/bg_BG.ts": "./components/locale/bg_BG.ts",
	"./locale/bn_BD.ts": "./components/locale/bn_BD.ts",
	"./locale/by_BY.ts": "./components/locale/by_BY.ts",
	"./locale/ca_ES.ts": "./components/locale/ca_ES.ts",
	"./locale/cs_CZ.ts": "./components/locale/cs_CZ.ts",
	"./locale/da_DK.ts": "./components/locale/da_DK.ts",
	"./locale/de_DE.ts": "./components/locale/de_DE.ts",
	"./locale/el_GR.ts": "./components/locale/el_GR.ts",
	"./locale/en_GB.ts": "./components/locale/en_GB.ts",
	"./locale/en_US.ts": "./components/locale/en_US.ts",
	"./locale/es_ES.ts": "./components/locale/es_ES.ts",
	"./locale/et_EE.ts": "./components/locale/et_EE.ts",
	"./locale/fa_IR.ts": "./components/locale/fa_IR.ts",
	"./locale/fi_FI.ts": "./components/locale/fi_FI.ts",
	"./locale/fr_BE.ts": "./components/locale/fr_BE.ts",
	"./locale/fr_CA.ts": "./components/locale/fr_CA.ts",
	"./locale/fr_FR.ts": "./components/locale/fr_FR.ts",
	"./locale/ga_IE.ts": "./components/locale/ga_IE.ts",
	"./locale/gl_ES.ts": "./components/locale/gl_ES.ts",
	"./locale/he_IL.ts": "./components/locale/he_IL.ts",
	"./locale/hi_IN.ts": "./components/locale/hi_IN.ts",
	"./locale/hr_HR.ts": "./components/locale/hr_HR.ts",
	"./locale/hu_HU.ts": "./components/locale/hu_HU.ts",
	"./locale/hy_AM.ts": "./components/locale/hy_AM.ts",
	"./locale/id_ID.ts": "./components/locale/id_ID.ts",
	"./locale/is_IS.ts": "./components/locale/is_IS.ts",
	"./locale/it_IT.ts": "./components/locale/it_IT.ts",
	"./locale/ja_JP.ts": "./components/locale/ja_JP.ts",
	"./locale/ka_GE.ts": "./components/locale/ka_GE.ts",
	"./locale/kk_KZ.ts": "./components/locale/kk_KZ.ts",
	"./locale/km_KH.ts": "./components/locale/km_KH.ts",
	"./locale/kmr_IQ.ts": "./components/locale/kmr_IQ.ts",
	"./locale/kn_IN.ts": "./components/locale/kn_IN.ts",
	"./locale/ko_KR.ts": "./components/locale/ko_KR.ts",
	"./locale/ku_IQ.ts": "./components/locale/ku_IQ.ts",
	"./locale/lt_LT.ts": "./components/locale/lt_LT.ts",
	"./locale/lv_LV.ts": "./components/locale/lv_LV.ts",
	"./locale/mk_MK.ts": "./components/locale/mk_MK.ts",
	"./locale/ml_IN.ts": "./components/locale/ml_IN.ts",
	"./locale/mn_MN.ts": "./components/locale/mn_MN.ts",
	"./locale/ms_MY.ts": "./components/locale/ms_MY.ts",
	"./locale/nb_NO.ts": "./components/locale/nb_NO.ts",
	"./locale/ne_NP.ts": "./components/locale/ne_NP.ts",
	"./locale/nl_BE.ts": "./components/locale/nl_BE.ts",
	"./locale/nl_NL.ts": "./components/locale/nl_NL.ts",
	"./locale/pl_PL.ts": "./components/locale/pl_PL.ts",
	"./locale/pt_BR.ts": "./components/locale/pt_BR.ts",
	"./locale/pt_PT.ts": "./components/locale/pt_PT.ts",
	"./locale/ro_RO.ts": "./components/locale/ro_RO.ts",
	"./locale/ru_RU.ts": "./components/locale/ru_RU.ts",
	"./locale/sk_SK.ts": "./components/locale/sk_SK.ts",
	"./locale/sl_SI.ts": "./components/locale/sl_SI.ts",
	"./locale/sr_RS.ts": "./components/locale/sr_RS.ts",
	"./locale/sv_SE.ts": "./components/locale/sv_SE.ts",
	"./locale/ta_IN.ts": "./components/locale/ta_IN.ts",
	"./locale/th_TH.ts": "./components/locale/th_TH.ts",
	"./locale/tr_TR.ts": "./components/locale/tr_TR.ts",
	"./locale/uk_UA.ts": "./components/locale/uk_UA.ts",
	"./locale/ur_PK.ts": "./components/locale/ur_PK.ts",
	"./locale/vi_VN.ts": "./components/locale/vi_VN.ts",
	"./locale/zh_CN.ts": "./components/locale/zh_CN.ts",
	"./locale/zh_HK.ts": "./components/locale/zh_HK.ts",
	"./locale/zh_TW.ts": "./components/locale/zh_TW.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components sync recursive ^\\.\\/locale\\/.+_.+\\.tsx?$";